import * as React from "react";
import { IdStyles } from "../../../../less/IdStyles";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../../utils/i18n/ReplacementLoca";
import { TextLoca } from "../../../generic/text/TextLoca";
export var BuildingItemLevel = function (_a) {
    var level = _a.level;
    var locaReplacements = new Map([[ReplacementLoca.zero_0, level.toString()]]);
    return (React.createElement("div", { className: IdStyles.TextBoldAccent },
        React.createElement(TextLoca, { id: IdLoca.stageX, replacements: locaReplacements })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingItemLevel.tsx
// module id = 2637
// module chunks = 3